import { autoserialize, autoserializeAs, inheritSerialization } from "cerialize";
import { NotificationType } from "./notification-type";
import { AbstractModel } from "@uzurv/core";

@inheritSerialization(AbstractModel)
export class Notification extends AbstractModel {
  @autoserialize
  userId: number;

  @autoserializeAs(NotificationType)
	notificationType: NotificationType;

  @autoserialize
	objectId: number;
}
